import { create } from 'zustand';
import type { NormalizedSaEvent } from '@vtak/shared';

interface CotState {
  events: NormalizedSaEvent[];
  previousPositions: Map<string, [number, number]>;
  setEvents: (events: NormalizedSaEvent[]) => void;
  updatePreviousPositions: (events: NormalizedSaEvent[]) => void;
}

/** Store for CoT situational awareness events with position tracking */
export const useCotStore = create<CotState>((set) => ({
  events: [],
  previousPositions: new Map(),

  setEvents: (events) => set({ events }),

  updatePreviousPositions: (events) =>
    set((state) => {
      const next = new Map(state.previousPositions);
      for (const evt of events) {
        next.set(evt.uid, [evt.lon, evt.lat]);
      }
      return { previousPositions: next };
    }),
}));
